import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { useCleanupRedux } from '../../common/hooks'
import { apolloService } from '../../common/services'

import { INGREDIENT_QUERY } from '../graphql/queries'
import { FETCH_INGREDIENT } from '../redux/action-types'
import { cleanupFetchIngredient } from '../redux/actions'

const useIngredientQuery = id => {
  const dispatch = useDispatch()
  useCleanupRedux(cleanupFetchIngredient)

  const { isFetchLoading, fetchError, data } = useSelector(
    store => store.ingredients.ingredient,
  )

  const refetch = useCallback(
    id =>
      apolloService.query(INGREDIENT_QUERY, { id }, dispatch, FETCH_INGREDIENT),

    [dispatch],
  )

  useEffect(() => {
    refetch(id)
  }, [id, refetch])

  return { isLoading: isFetchLoading, error: fetchError, data, refetch }
}

export default useIngredientQuery
